import { render } from "./PowerIcon.vue?vue&type=template&id=63038bcb"
const script = {}
script.render = render

export default script